import React from 'react';

const Gear: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    height="20"
    fill="none"
    viewBox="0 0 20 20"
    width="20"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d={`M12.2059 3.40039C12.2282 3.49267 12.2721 3.57836 12.3338
      3.65051C12.3955 3.72266 12.4734 3.77923 12.5611 3.81561C12.6488
      3.85198 12.7438 3.86715 12.8385 3.85988C12.9332 3.8526 13.0248
      3.82308 13.1059 3.77372C15.1384 2.53622 17.4642 4.86122 16.2267
      6.89372C16.1774 6.97478 16.1478 7.06633 16.1405 7.16095C16.1332
      7.25557 16.1482 7.35058 16.1845 7.43827C16.2208 7.52595 16.2773
      7.60384 16.3494 7.6656C16.4214 7.72737 16.507 7.77126 16.5992
      7.79372C18.9117 8.35456 18.9117 11.6437 16.5992 12.2054C16.5069
      12.2277 16.4212 12.2716 16.3491 12.3333C16.2769 12.395 16.2204
      12.4729 16.184 12.5606C16.1476 12.6483 16.1325 12.7433 16.1397
      12.838C16.147 12.9327 16.1765 13.0243 16.2259 13.1054C17.4634
      15.1379 15.1384 17.4637 13.1059 16.2262C13.0248 16.1769 12.9333
      16.1473 12.8387 16.14C12.744 16.1327 12.649 16.1478 12.5613
      16.1841C12.4737 16.2203 12.3958 16.2768 12.334 16.3489C12.2722
      16.4209 12.2283 16.5065 12.2059 16.5987C11.645 18.9112 8.35588
      18.9112 7.79421 16.5987C7.77185 16.5064 7.72803 16.4208 7.66631
      16.3486C7.60459 16.2765 7.52672 16.2199 7.43902 16.1835C7.35132
      16.1471 7.25627 16.132 7.1616 16.1392C7.06694 16.1465 6.97532
      16.176 6.89421 16.2254C4.86171 17.4629 2.53588 15.1379 3.77338
      13.1054C3.82274 13.0243 3.85228 12.9328 3.85961 12.8382C3.86694
      12.7435 3.85184 12.6485 3.81555 12.5609C3.77926 12.4732 3.72279
      12.3953 3.65074 12.3335C3.57869 12.2717 3.49308 12.2279 3.40088
      12.2054C1.08838 11.6446 1.08838 8.35539 3.40088 7.79372C3.49316
      7.77137 3.57885 7.72755 3.651 7.66583C3.72315 7.60411 3.77971
      7.52623 3.81609 7.43853C3.85247 7.35083 3.86764 7.25578 3.86036
      7.16111C3.85309 7.06645 3.82357 6.97483 3.77421 6.89372C2.53671
      4.86122 4.86171 2.53539 6.89421 3.77289C6.97518 3.82262 7.06678
      3.85247 7.16151 3.85999C7.25624 3.8675 7.3514 3.85248 7.4392
      3.81614C7.527 3.7798 7.60495 3.72318 7.66665 3.65091C7.72836
      3.57865 7.77207 3.4928 7.79421 3.40039C8.35505 1.08789 11.6442
      1.08789 12.2059 3.40039ZM10 7.49956C9.337 7.49956 8.70112 7.76295
      8.23228 8.23179C7.76344 8.70063 7.50005 9.33652 7.50005
      9.99956C7.50005 10.6626 7.76344 11.2985 8.23228 11.7673C8.70112
      12.2362 9.337 12.4996 10 12.4996C10.6631 12.4996 11.299 12.2362
      11.7678 11.7673C12.2367 11.2985 12.5 10.6626 12.5 9.99956C12.5
      9.33652 12.2367 8.70063 11.7678 8.23179C11.299 7.76295 10.6631
      7.49956 10 7.49956Z`} fill="#98A2B3"/>
  </svg>
);

export default Gear;
